module.exports = __webpack_public_path__ + "static/media/mainbg.441a9c75.png";